const capabilities = [
  {
    sectionId: 'engineering',
    img: 'https://img.magnific.com/free-vector/geometric-shape-perspective-floor_1409-1837.jpg?semt=ais_hybrid&w=740&q=80',
    alt: 'Engineering Support',
    title: 'Engineering Support from Design to Production',
    linkText: 'Read More',
  },
  {
    sectionId: 'custom',
    img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcScD29UO0MJpTV0_xOFkIdYDx0gwQHhYL1axG0Kh1LKbgAEoSl6Lwdf4Lo&s=10',
    alt: 'Custom Wiring Harness Solutions',
    title: 'Custom Wiring Harnesses for Your Application',
    linkText: 'Read More',
  },
  {
    sectionId: 'quality',
    img: 'https://img.magnific.com/free-photo/future-visions-business-technology-concept_23-2151893464.jpg?semt=ais_hybrid&w=740&q=80',
    alt: 'Quality Manufacturing',
    title: 'Reliable Manufacturing Quality at Every Stage',
    linkText: 'Read More',
  },
  {
    sectionId: 'industries',
    img: 'https://img.magnific.com/premium-photo/fiber-optic-cable-texture_1271330-3746.jpg?semt=ais_hybrid&w=740&q=80',
    alt: 'Industrial Connectivity Solutions',
    title: 'Solutions for Automotive, Industrial & Energy',
    linkText: 'Read More',
  },
];

export default capabilities;